import { modulesName } from '@/modules';
import store from '@/store';
import { authHandler } from './auth-handler';
import { requestErrorHandler, responseErrorHandler } from './error-handler';

export const requestInterceptor = {
  onFulfilled: async (config) => {
    const skipLoading = config?.headers?.skipLoading;
    if (!skipLoading) {
      // start loading
      store.dispatch(`${modulesName.appModuleName}/setLoading`, true);
    }
    await authHandler(config);
    return config;
  },

  onRejected: (error) => {
    // stop loading
    store.dispatch(`${modulesName.appModuleName}/setLoading`, false);
    requestErrorHandler(error);
    return error;
  },
};

export const responseInterceptor = {
  onFulfilled(response) {
    // stop loading
    store.dispatch(`${modulesName.appModuleName}/setLoading`, false);
    return response;
  },

  onRejected(error) {
    // stop loading
    store.dispatch(`${modulesName.appModuleName}/setLoading`, false);
    responseErrorHandler(error);
    return error;
  },
};
